




import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class MTextField extends Vue {
  focus() {
    (this.$refs.input as HTMLInputElement)?.focus();
  }
}
